import { Action } from 'redux';
import { findBrandHistory, findBrandsHistory } from '~/Api/Analytics/VirtualBrand/History';
import { invokeApi, tryResolve } from '~/ApiClient';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';
import { Query, selectHistory } from './reducer';

export function fetchHistory(query: Query, page: number, perPage = 100): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = query.id
			? dispatch(invokeApi(findBrandHistory, query, page, perPage))
			: dispatch(invokeApi(findBrandsHistory, query, page, perPage));

		dispatch({ type: ActionTypes.request, request, query });

		await tryResolve(request, (response, error) => {
			dispatch({
				type: ActionTypes.receive,
				request,
				query,
				items: response?.items,
				pagination: response?.pagination,
			});
			if (error) {
				dispatch(handleError(error));
			}
		});
	};
}

export function fetchMoreHistory(query: Query, perPage = 100): ThunkAction<Promise<void>, any> {
	return async (dispatch, getState) => {
		const historyState = selectHistory(getState().medicinalBrandsAnalyticsHistory, query);
		if (!historyState || !historyState.pagination) {
			await dispatch(fetchHistory(query, 1, perPage));
			return;
		}

		const { pagination } = historyState;
		const nextPage = pagination.getNextPage();
		if (nextPage) {
			await dispatch(fetchHistory(query, nextPage, pagination.perPage));
		}
	};
}

export function pruneHistory(query: Query): Action<ActionTypes.prune> & {
	query: Query;
} {
	return { type: ActionTypes.prune, query };
}
